/**
 * Views that can be turned on or off via the top bar menus.
 * These view on / off states are persisted to device settings.
 */
export enum ViewType {
  SIDEBAR = "SIDEBAR",
  DATA_PANE = "DATA_PANE",
  COMPETITIONS_PANE = "COMPETITIONS_PANE",
  SETTINGS_PANE = "SETTINGS_PANE",
  DEBUG_PANE = "DEBUG_PANE",
  SNIPPETS_PANE = "SNIPPETS_PANE",
  JUPYTER_DEV_TOOLS = "JUPYTER_DEV_TOOLS",
  // TODO(cochamberlain): Add tracking of expansion to Redux state.
  JUPYTER_DEV_TOOLS_EVENTS_PANE = "JUPYTER_DEV_TOOLS_EVENTS_PANE",
  JUPYTER_DEV_TOOLS_REDUX_PANE = "JUPYTER_DEV_TOOLS_REDUX_PANE",
  INTERACTIVE_SESSIONS = "INTERACTIVE_SESSIONS",
  COMMIT_SESSIONS = "COMMIT_SESSIONS",
}
